import CategoryHead from '@/components/categoryHead';
import MainContent from './mainContent';
import TopicContent from './topicContent';
import { useLocation, useParams } from 'react-router-dom';
import Footer from '@/components/footer';
import { useEffect, useState } from 'react';
import useAxios from '@/hooks/useAxios';
import u from '@/util';
import enterStyles from "../user/styles/enter.module.css"

function MainIndex() {
  const { channel } = useParams()
  const category = [] as any;
      const { req: getProToken } = useAxios("user/loginByProToken", "post");
    const { req: getUserDetails } = useAxios("user/userDetails", "post");
      const location = useLocation();
      const [isOpenPopup, setIsOpenPopup] = useState(false);
      const [pendingToken, setPendingToken] = useState<{
        token: string;
        type: 'mm' | 'mmp';
      } | null>(null);
      const [pendingUserData, setPendingUserData] = useState<any | null>(null);

      const handleTokenExtraction = async () => {
        const urlParams = new URLSearchParams(location.search);
        const mmToken = urlParams.get('mm');
        const mmpToken = urlParams.get('mmp');
      
        console.log('handleTokenExtraction called, URL search:', location.search);
        console.log('Extracted mm token:', mmToken);
        console.log('Extracted mmp token:', mmpToken);
      
        // Check if we already have a token stored
        // const existingToken = localStorage.getItem('_USER');
        // const existingTokenName = localStorage.getItem('token_name');
      
        // Process token if it exists and no valid token is stored
        // if ((mmToken || mmpToken) && (!existingToken || !existingTokenName)) {
          // Prefetch user info for both mm and mmp tokens, then show confirmation dialog
          if (mmToken) {
            const fetched = await processToken(mmToken, 'mm');
            if (fetched) {
              console.log("show fetched data", fetched);
    
              setPendingUserData(fetched);
              setPendingToken({ token: mmToken, type: 'mm' });
              setIsOpenPopup(true);
            }
            return;
          }
          if (mmpToken) {
            const fetched = await processToken(mmpToken, 'mmp');
            if (fetched) {
              console.log("show fetched data", fetched);
              setPendingUserData(fetched);
              setPendingToken({ token: mmpToken, type: 'mmp' });
              setIsOpenPopup(true);
            }
            return;
          }
        // } else if (mmToken || mmpToken) {
        //   console.log('Token already exists, skipping extraction');
        // } else {
        //   console.log('No mm or mmp token found in URL');
        // }
      };
        
        const processToken = async (token: string, type: 'mm' | 'mmp') => {
          let apiUrl: string;
          let params: { [key: string]: string };
      
          if (type === 'mm') {
            params = { provider: "luntan" , provider_token: token }; // Example parameters for mm
            console.log('Processing mm token:', token);
          } else {
            params = { token: token };
            console.log('Processing mmp token:', token);
          }
      
          let res;
          if (type === 'mm') {
              res = await getProToken(params); // Use getProToken for mmToken
              console.log('Response from getProToken:', res, params);
          } else if (type === 'mmp') {
               res = await getUserDetails(params); // Use getProToken for mmToken
              console.log('Response from getUserDetails:', res, params);
          }
      
            if (res?.code === 0) {
              console.log(`Successful response from:`, res.data.data, params);
              return res.data.data;
            } else {
              console.log(`Failed response from:`, res);
              return null;
            }
          } 
  
        useEffect(() => {
          console.log('location.search', location.search);
          handleTokenExtraction();
        }, [location.search]);
  
        const handleTokenConfirm = async () => {
          setIsOpenPopup(false);
          if (pendingToken && pendingUserData) {
            if (pendingToken.type === 'mm') {
              localStorage.setItem('_USER', u.encrypt(JSON.stringify(pendingUserData.user)));
              localStorage.setItem('token_name', 'mm');
            } else {
              localStorage.setItem('_USER', u.encrypt(JSON.stringify(pendingUserData)));
              localStorage.setItem('token_name', 'mmp');
            }
            // Clean up URL token parameter after confirmation
            const newUrl = new URL(window.location.href);
            newUrl.searchParams.delete(pendingToken.type === 'mm' ? 'mm' : 'mmp');
            window.history.replaceState({}, '', newUrl.toString());
          }
          setPendingToken(null);
          setPendingUserData(null);
          window.location.reload();
        };
  
        const handleTokenCancel = () => {
          // Clean up URL without storing token
          const urlParams = new URLSearchParams(window.location.search);
          if (urlParams.get('mm')) {
            const newUrl = new URL(window.location.href);
            newUrl.searchParams.delete('mm');
            window.history.replaceState({}, '', newUrl.toString());
            console.log('URL cleaned up - user chose manual login (mm token)');
          } else if (urlParams.get('mmp')) {
            const newUrl = new URL(window.location.href);
            newUrl.searchParams.delete('mmp');
            window.history.replaceState({}, '', newUrl.toString());
            console.log('URL cleaned up - user chose manual login (mmp token)');
          }
          
          setIsOpenPopup(false);
          setPendingToken(null);
          setPendingUserData(null);
          return window.location.href = "/login"
        };
    
        const handleClose = () => {
          // Clean up URL without storing token
          const urlParams = new URLSearchParams(window.location.search);
          if (urlParams.get('mm')) {
            const newUrl = new URL(window.location.href);
            newUrl.searchParams.delete('mm');
            window.history.replaceState({}, '', newUrl.toString());
            console.log('URL cleaned up - user chose manual login (mm token)');
          } else if (urlParams.get('mmp')) {
            const newUrl = new URL(window.location.href);
            newUrl.searchParams.delete('mmp');
            window.history.replaceState({}, '', newUrl.toString());
            console.log('URL cleaned up - user chose manual login (mmp token)');
          }
          
          setIsOpenPopup(false);
          setPendingToken(null);
          setPendingUserData(null);
        };
  

  return (
    <div className=''>
      <CategoryHead showCategory flag={1}>
        {!channel && window.location.href.indexOf("topic") === -1 && <MainContent list={category} />}
        {window.location.href.indexOf("topic") >= 0 && <TopicContent list={category} />}
        <Footer />
      </CategoryHead>

            {isOpenPopup && pendingToken && (
            <div className={enterStyles.overlay} style={{zIndex:'999999'}}>
                <div className={enterStyles.modal}>
                    <button
                        onClick={handleClose}
                        aria-label="Close"
                        className={enterStyles.closeBtn}
                    >
                        ×
                    </button>
                    <div className={enterStyles.center}>
                        {pendingToken.type === 'mm' ? (
                            <div className="w-full">
                                <img className={enterStyles.modalImg} src={`/assets/images/luntantoav.png`} alt="view" />
                                <div className={enterStyles.modalTitle}>
                                    <p className={enterStyles.logintitle}>您即将进入猫咪AV</p>
                                    <p className={enterStyles.loginusername}>@{pendingUserData?.user?.username}</p>
                                </div>
                                <div>
                                    <button onClick={handleTokenConfirm} className={enterStyles.primaryBtn}>使用猫咪账号进行登入</button>
                                    <button onClick={handleTokenCancel} className={enterStyles.secondaryBtn}>登录其他账号</button>
                                </div>
                            </div>
                        ) : (
                            <div className="w-full">
                                <img className={enterStyles.modalImg} src={`/assets/images/pictoav.png`} alt="view" />
                                <div className={enterStyles.modalTitle}>
                                    <p className={enterStyles.logintitle}>您即将进入猫咪AV</p>
                                    <p className={enterStyles.loginusername}>@{pendingUserData?.username}</p>
                                </div>
                                <div>
                                    <button onClick={handleTokenConfirm} className={enterStyles.primaryBtn}>使用猫咪账号进行登入</button>
                                    <button onClick={handleTokenCancel} className={enterStyles.secondaryBtn}>登录其他账号</button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        )}
    </div>
  );
}

export default MainIndex;
